import React from 'react';
import styled from 'styled-components';
import { default as BaseWrapper } from '../Wrapper';

const Separator = styled(BaseWrapper)`
  margin-top: 16px;
  border-bottom: 1px solid #bfc5cf;
  margin-bottom: 20px;
`;

const Wrapper = styled(BaseWrapper)`
  margin-top: 16px;
  background-color: #f2f3f6;
`;

const Footer = () => {
  return (
    <Wrapper display={['none', 'block']}>
      <Separator />
      <aa-footer />
    </Wrapper>
  );
};

export default Footer;
